// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.LedPatternClass+input {\n  display: contents !important;\n}\n", ""]);
// Exports
module.exports = exports;
